import { render } from "./deCookieBanner.vue?vue&type=template&id=58e1c8c3"
import script from "./deCookieBanner.vue?vue&type=script&lang=js"
export * from "./deCookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__